<template>
	<div class="center_info_content">
		<div v-if="pubInfo.pubName" class="detail-header">
			<img :src="pubInfo.images[0].url" height="300" width="400" />
			<div style="margin-left: 16px">
				<div class="detail-title" v-html="pubInfo.pubName"></div>
				<span v-for="(item, index) in pubInfo.tags" :key="index">
					{{ item }}
					<span v-if="index !== pubInfo.tags.length - 1">|</span>
				</span>
				<div class="detail-hint" v-html="pubInfo.specials"></div>
				<div style="margin-top: 20px">
					<el-button :loading="isLoading" size="medium" type="warning" @click.native="onDetailDeal(1)">
						立即投保
					</el-button>
					<el-button :loading="isLoading" size="medium" type="primary" @click.native="onDetailDeal(2)">
						投保计划书
					</el-button>
				</div>
				<div v-if="pubInfo.professionDownload && pubInfo.professionDownload.show === 1" style="margin-top: 15px">
					<el-button
						:loading="isLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="onDetailDeal(3)">
						{{ pubInfo.professionDownload.label }}
					</el-button>
				</div>
			</div>
		</div>

		<el-tabs v-if="pubDetailData.tabs && pubDetailData.tabs.length > 0" v-model="currentStep">
			<el-tab-pane
				v-for="(
					{
						content: {text = '', qa = [], files = []} = {},
						contentType = '',
						key = '',
						label = '',
						notices = [],
						searches = [],
						show = 0,
					},
					index
				) in pubDetailData.tabs"
				:key="index"
				:label="label"
				:name="`${index}`">
				<div v-if="notices.length > 0">
					<el-alert
						v-for="(itemData, index1) in notices"
						:key="index1"
						:closable="false"
						:type="itemData.type ? itemData.type : 'warning'"
						show-icon
						style="margin-bottom: 10px">
						<template v-slot:title>
							<span class="u-font-weight-bold" v-html="itemData.content"></span>
						</template>
					</el-alert>
				</div>
				<div v-if="searches.length > 0" style="display: flex; align-items: center">
					<div
						v-for="({label: label1, key, options = [], placeholder}, index1) in searches"
						:key="index1"
						style="margin: 15px 20px">
						<span style="margin-right: 20px">{{ label1 }}：</span>
						<el-select v-model="searchData[key]" :placeholder="placeholder" @change="onChangeSelect(key)">
							<el-option
								v-for="{label: label2, value: value2} in options"
								:key="value2"
								:label="label2"
								:value="value2"></el-option>
						</el-select>
					</div>
				</div>
				<el-card>
					<div v-if="contentType === 'RICH_TEXT'" v-html="text"></div>
					<div v-else-if="contentType === 'QA'">
						<el-row>
							<el-col :span="20">
								<div v-for="({question, answer}, index1) in qa" :key="index1">
									<span class="answer-custom answer-title" style="font-weight: bold" v-html="question"></span>
									<div style="margin-top: 10px">
										<div class="answer-custom answer-content" style="margin-top: 10px" v-html="answer"></div>
									</div>
									<el-divider></el-divider>
								</div>
							</el-col>
						</el-row>
					</div>
					<div v-else-if="contentType === 'FILE_UPLOAD'">
						<!--下载类型-->
						<avue-crud
							v-if="getPdfData(files).length > 0"
							ref="crud_content"
							:data="getPdfData(files)"
							:option="downloadOptionData">
							<template slot="menu" slot-scope="{row}">
								<div style="display: flex; justify-content: center; width: 100%">
									<el-button icon="el-icon-download" type="text" @click="onDownload(row)">下载</el-button>
								</div>
							</template>
						</avue-crud>
						<!--图片类型-->
						<div v-if="getImgData(files).length > 0">
							<el-image v-for="({url}, index1) in getImgData(files)" :key="index1" :src="url"></el-image>
						</div>
					</div>
				</el-card>
			</el-tab-pane>
		</el-tabs>

		<div v-else>
			<el-tabs v-if="pubDetailData.detailModels" v-model="currentStep">
				<el-tab-pane label="保险详情" name="0">
					<div v-if="pubDetailData.notices">
						<el-alert
							v-for="(itemData, index) in pubDetailData.notices"
							:key="index"
							:closable="false"
							:type="itemData.type"
							show-icon
							style="margin-bottom: 10px">
							<template v-slot:title>
								<span class="u-font-weight-bold" v-html="itemData.content"></span>
							</template>
						</el-alert>
					</div>
					<div v-if="pubDetailData.searchForms" style="display: flex; align-items: center">
						<div
							v-for="({label, type, key, options = [], placeholder}, index) in pubDetailData.searchForms"
							style="margin: 15px 20px">
							<span style="margin-right: 20px">{{ label }}：</span>
							<el-select
								v-if="type === 'select'"
								v-model="searchData[key]"
								:placeholder="placeholder"
								@change="onChangeSelect(key)">
								<el-option
									v-for="{label: label1, value: value1} in options"
									:key="value1"
									:label="label1"
									:value="value1"></el-option>
							</el-select>
						</div>
					</div>
					<el-card v-for="({content}, index) in pubDetailData.detailModels" :key="index">
						<div v-html="content"></div>
					</el-card>
				</el-tab-pane>
				<el-tab-pane label="常见问题" name="1">
					<el-card>
						<el-row>
							<el-col :span="16">
								<div v-for="({question, answer}, index) in pubDetailData.productQas" :key="index">
									<span class="answer-custom answer-title" style="font-weight: bold" v-html="question"></span>
									<div style="margin-top: 10px">
										<div class="answer-custom answer-content" style="margin-top: 10px" v-html="answer"></div>
									</div>
									<el-divider></el-divider>
								</div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane :label="isLibaoGuzhu(insureType) ? '特别约定' : '投保须知'" name="2">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div v-html="pubDetailData.declareContent"></div>
								<div style="margin-top: 20px" v-html="pubDetailData.specialAppoint"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.attachments && pubDetailData.attachments.length > 0" label="下载" name="3">
					<avue-crud ref="crud_content" :data="pubDetailData.attachments" :option="downloadOptionData">
						<template slot="menu" slot-scope="{row}">
							<div style="display: flex; justify-content: center; width: 100%">
								<el-button icon="el-icon-download" type="text" @click="onDownload(row)">下载</el-button>
							</div>
						</template>
					</avue-crud>
				</el-tab-pane>

				<el-tab-pane v-if="pubDetailData.clauseDesc" label="保险条款" name="4">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.clauseDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.productDesc" label="产品说明" name="5">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.productDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.claimDesc" label="理赔须知" name="6">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.claimDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.dutyExemptDesc" label="责任免除" name="7">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.dutyExemptDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.disclosureDesc" label="信息披露" name="8">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.disclosureDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
				<el-tab-pane v-if="pubDetailData.personalInfoProtectDesc" label="个人信息保护政策" name="9">
					<el-card>
						<el-row>
							<el-col :span="22">
								<div style="margin-top: 20px" v-html="pubDetailData.personalInfoProtectDesc"></div>
							</el-col>
						</el-row>
					</el-card>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import InsureNotices from './InsureNotices'
import {validatenull} from '../util/validate'
import {downloadNewOption} from '../option/insureOption'
import {isLibaoGuzhu} from '../util/productUtil'

export default {
	name: 'InsureInfoDetailCustom',
	components: {InsureNotices},
	props: {
		pubInfo: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		pubDetail: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		isLoading: {
			type: Boolean,
			required: true,
			default: false,
		},
		insureType: Number | String,
	},
	data() {
		return {
			currentStep: '0',
			searchData: {},
			isShowNotices: false,
			noticesData: {},
			downloadOptionData: this.deepClone(downloadNewOption),
			pubDetailData: this.deepClone(this.pubDetail),
		}
	},
	watch: {
		pubDetail: {
			handler(newVal, oldVal) {
				if (!validatenull(newVal)) {
					//不为空，则处理可选择的数据
					this.pubDetailData = this.deepClone(newVal)
					//处理搜索数据
					this.onDealSearchData()
				}
			},
			immediate: true,
		},
	},
	created() {},
	methods: {
		isLibaoGuzhu,
		//1 投保提醒，2计划书，3 下载职业类别 4,直接进入投保
		onDetailDeal(type) {
			this.$emit('onDetailDeal', type)
		},
		onShowNotices(noticesData) {
			this.noticesData = noticesData
			this.isShowNotices = true
		},
		//详情页搜索
		onChangeSelect(key) {
			console.log(key, '---1')
			//调用接口请求筛选
			this.$emit('onDetailSearch', this.searchData)
		},
		//搜索设置数据
		setSearchData(searchData = {}) {
			let {tabs = []} = searchData
			if (tabs && tabs.length > 0) {
				//初始化数据
				this.pubDetailData.tabs = tabs
				//处理搜索数据
				this.onDealSearchData()
			} else {
				Object.assign(this.pubDetailData, searchData)
			}
		},
		//下载
		onDownload({url}) {
			window.open(url, '_blank')
		},
		//处理搜索数据
		onDealSearchData() {
			let {tabs = [], searchForms = []} = this.pubDetailData
			if (tabs && tabs.length > 0) {
				for (let {searches = []} of tabs) {
					this.onAddSearchParams(searches)
				}
			} else {
				//处理一般search
				this.onAddSearchParams(searchForms)
			}
			console.log(this.searchData, '--------')
		},
		onAddSearchParams(searches = []) {
			if (searches.length > 0) {
				for (let {key, defaultValue} of searches) {
					if (!this.searchData[key]) {
						this.$set(this.searchData, key, defaultValue)
					}
				}
			}
		},
		getPdfData(files) {
			return files.filter(({fileType = ''}) => fileType === 'pdf')
		},
		getImgData(files) {
			return files.filter(({fileType = ''}) => fileType === 'png')
		},
	},
}
</script>

<style lang="scss" scoped>
.detail-header {
	display: flex;
	justify-content: left;
	padding: 20px;
}

.detail-title {
	font-size: 26px;
	font-weight: bold;
}

.detail-hint,
.detail-title {
	::v-deep p {
		margin: 10px 0;
	}
}

.answer-custom {
	&:before {
		content: '';
		width: 22px;
		height: 26px;
		color: white;
		line-height: 25px;
		text-align: center;
		border-radius: 4px;
		margin-right: 10px;
		display: inline-block;
	}
}

.answer-title {
	&:before {
		content: 'Q';
		background-color: MediumPurple;
	}
}

.answer-content {
	::v-deep p {
		&:first-child {
			display: inline;
		}

		display: inline-block;
		margin: 8px 0;
	}

	&:before {
		content: 'A';
		background-color: green;
	}
}

.red-bold {
	font-weight: bold;
	color: red;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

::v-deep .el-alert {
	height: 40px;
}
</style>
